// extracted by mini-css-extract-plugin
export default {"number":"vbxqT","number--bought":"A9Adk","showAllLink":"ZFbIJ","link":"o9lMl","number-refresh":"bGbuP","refreshIcon":"LRtRP","fancyNumberButton":"YV1dB"};